var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content booking-channel-config" }, [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "60px",
                      "label-position": "left"
                    },
                    nativeOn: {
                      submit: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w400",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "searchBranchId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office,
                                multiple: true,
                                clearable: true,
                                filterable: "",
                                "default-multiple-value":
                                  _vm.searchConditions.branchId,
                                "tag-value": "officeId",
                                "tag-name": "code",
                                "filter-tag-names": [
                                  "englishName",
                                  "chineseName",
                                  "code"
                                ],
                                cache: false,
                                "static-options": _vm.officeList,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.searchConditions.branchId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w540",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CarrierShip")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "searchCarrierId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                multiple: true,
                                clearable: true,
                                filterable: "",
                                "default-multiple-value":
                                  _vm.searchConditions.carrierId,
                                "method-params": {
                                  companyLob: "seaExport",
                                  seaCmp: true,
                                  active: true
                                },
                                "callback-method-type": "value",
                                "callback-params": { key: "carrierId" },
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.searchConditions.carrierId = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "triggers" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.toQuery }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.popMappingAddDialog }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.popMappingEditFormDialog }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.toBatchDel }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "grid-options": _vm.gridOptions,
                  "side-bar": _vm.sideBarDefs
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "260311",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchData
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.isShowDialogForm,
            title: _vm.dialogTitle,
            width: "400px",
            "custom-class": "booking-channel-config-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDialogForm = $event
            }
          }
        },
        [
          _c("div", { staticClass: "details-view" }, [
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "mappingForm",
                    attrs: {
                      model: _vm.mappingForm,
                      "label-width": "100px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_OperationOffice")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "branchId",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Office,
                                multiple: true,
                                clearable: false,
                                filterable: "",
                                "default-multiple-value":
                                  _vm.mappingForm.branchIdList,
                                "tag-value": "officeId",
                                "tag-name": "code",
                                "filter-tag-names": [
                                  "englishName",
                                  "chineseName",
                                  "code"
                                ],
                                cache: false,
                                "static-options": _vm.officeList,
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mappingForm.branchIdList = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { staticClass: "el-form-item-w320" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                                )
                              ]
                            ),
                            _c("cargo-company-select", {
                              attrs: {
                                no: "carrierId",
                                "method-params": {
                                  companyLob: "seaExport",
                                  seaCmp: true,
                                  active: true
                                },
                                "default-value": _vm.mappingForm.carrierId || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.mappingForm.carrierId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "bookingAgent",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                filterable: "",
                                "method-params": {
                                  bookingAgent: true,
                                  companyLob: "seaExport",
                                  active: true
                                },
                                "default-value":
                                  _vm.mappingForm.bookingAgent || ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.mappingForm.bookingAgent = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: { label: _vm.$t("SeaExport.CarrierAgent") }
                          },
                          [
                            _c("cargo-company-select", {
                              attrs: {
                                no: "carrierAgentId",
                                "method-params": {
                                  seaCmpAgent: true,
                                  companyLob: "seaExport",
                                  active: true
                                },
                                "default-value":
                                  _vm.mappingForm.carrierAgentId || ""
                              },
                              on: {
                                change: function(p) {
                                  _vm.mappingForm.carrierAgentId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { staticClass: "el-form-item-w320" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BookingMode"))
                                )
                              ]
                            ),
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "bookingMode" },
                                model: {
                                  value: _vm.mappingForm.bookingMode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mappingForm,
                                      "bookingMode",
                                      $$v
                                    )
                                  },
                                  expression: "mappingForm.bookingMode"
                                }
                              },
                              _vm._l(_vm.BOOKING_MODES, function(item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.code,
                                    attrs: { label: item.code }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isZh
                                          ? item.chineseName
                                          : item.englishName
                                      )
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RpaSupplier")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "rpaSupplier" },
                                model: {
                                  value: _vm.mappingForm.rpaSupplier,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mappingForm,
                                      "rpaSupplier",
                                      $$v
                                    )
                                  },
                                  expression: "mappingForm.rpaSupplier"
                                }
                              },
                              _vm._l(_vm.RPA_SUPPLIERS, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: _vm.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_BookingChannel")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "bookingChannel", clearable: "" },
                                model: {
                                  value: _vm.mappingForm.bookingChannel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mappingForm,
                                      "bookingChannel",
                                      $$v
                                    )
                                  },
                                  expression: "mappingForm.bookingChannel"
                                }
                              },
                              _vm._l(_vm.BOOKING_CHANNELS, function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: _vm.isZh
                                      ? item.chineseName
                                      : item.englishName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AccountNumber")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "authUser" },
                              model: {
                                value: _vm.mappingForm.authUser,
                                callback: function($$v) {
                                  _vm.$set(_vm.mappingForm, "authUser", $$v)
                                },
                                expression: "mappingForm.authUser"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Password") }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "authPassword" },
                              model: {
                                value: _vm.mappingForm.authPassword,
                                callback: function($$v) {
                                  _vm.$set(_vm.mappingForm, "authPassword", $$v)
                                },
                                expression: "mappingForm.authPassword"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_WebSite") }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "webSite" },
                              model: {
                                value: _vm.mappingForm.webSite,
                                callback: function($$v) {
                                  _vm.$set(_vm.mappingForm, "webSite", $$v)
                                },
                                expression: "mappingForm.webSite"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "el-form-item-w320",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_CompanyCode")
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { no: "companyCode" },
                              model: {
                                value: _vm.mappingForm.companyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.mappingForm, "companyCode", $$v)
                                },
                                expression: "mappingForm.companyCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_ReceiptConfig"))
                                )
                              ]
                            ),
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "receiptConfig" },
                                model: {
                                  value: _vm.mappingForm.receiptConfig,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.mappingForm,
                                      "receiptConfig",
                                      $$v
                                    )
                                  },
                                  expression: "mappingForm.receiptConfig"
                                }
                              },
                              _vm._l(_vm.RECEIPT_CONFIGS, function(item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.code,
                                    attrs: { label: item.code }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isZh
                                          ? item.chineseName
                                          : item.englishName
                                      )
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini " },
                  on: {
                    click: function($event) {
                      _vm.isShowDialogForm = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }